export const setCurrentTab = '@event/setCurrentTab';
export const setCurrentDate = '@event/setCurrentDate';
export const setEventItems = '@event/setEventItems';
export const setSelectedItem = '@event/setSelectedItem';
export const setModalOpen = '@event/setModalOpen';
export const setModalType = '@event/setModalType';
export const setReload = '@event/setReload';
export const setPopOverAnchor = '@event/setPopOverAnchor';
export const setPopOverOpen = '@event/setPopOverOpen';
export const setNewDate = '@event/setNewDate';
export const setUpcomingEventCentral = '@event/setUpcomingEventCentral';
